import useMediaQuery from 'usehooks-ts/dist/esm/useMediaQuery/useMediaQuery'

export const useSmallDesktopQuery = () => {
  return useMediaQuery(`(min-width: ${1024}px) and (max-width: ${1439}px)`)
}
